import { PartnerExtIdsModel } from '../../../store';

export class PartnersSelectionItem {
  id: number;
  name: string;
  extIds?: PartnerExtIdsModel[];

  constructor(params?: PartnersSelectionItem) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
